
export default {
  layout: 'technos',
  mounted() {
    new RDStationForms(
      'inscricoes-meu-primeiro-emprego-b3951575538ece564347',
      'UA-228576147-2'
    ).createForm()
  },
}
